export * from './legal-views.module';
